import React from "react";
import Navbar from '../navBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { PrimeReactProvider } from 'primereact/api';
import "primereact/resources/themes/md-dark-indigo/theme.css";
import "primereact/resources/primereact.min.css"
import 'primeicons/primeicons.css';
import 'react-slideshow-image/dist/styles.css'
import { useTranslation } from "react-i18next";
import FooterComponent from "../footer";
import "../../style/table.css"
import TableFeldspat from "../feldspatTable";
import { Menu } from "primereact/menu";
import FeldspatMenu from "../feldspatMenu";
import "../../style/commonMobile.css";

const FeldspatKMEX7101 = (props) => {
    const { t, i18n } = useTranslation();
    return (
        <PrimeReactProvider>
            <Navbar />
            <div className="feldspatContainer">
                <div style={{ display: "block" }}>
                    <FeldspatMenu />
                </div>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "center" }}>
                    <TableFeldspat baslik="TEKNOMADEN FELDSPAR (-212 MICRON) 98KMEX-KF7101 TDS" plantAddress="Yeşilköy/Kavaklıdere/Muğla" kod="98KMEX-KF7101" humidity="0.3" oilAbsorb="" na2o="7.32" k2o="0.07" cao="0.25" fe2o3="0.01" tio2="0.15" al2o3="13.74" mgo="0.16" p2o5="0.00" sio2="77.87" kk="0.43" l="88.00" a="0.48" b="7.50" albit="61.9" ortoklas="0.4" anortit="1.2" kaolinit="3.0" kuvars="33.5" />
                </div>
            </div>
            <FooterComponent />
        </PrimeReactProvider>
    );
}
export default FeldspatKMEX7101;